import React from "react";

const LimitlessPossibilies = () => {
  const title = (
    <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug ">
      Limitless Possibilities
    </h4>
  );
  return (
    <section
      className="z-50 relative overflow-x-hidden"
      id="limitless_possibilies"
    >
      <div
        className="bg-black pt-20  pb-1  bg-no-repeat bg-cover "
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/avm90_limitless_possibilities_bg.jpg" +
            ")",
        }}
      >
        <div className="relative ">
          <img
            className="absolute xl:-right-1 lg:-right-60 top-1 lg:h-full  md:-right-28 sm:-right-40 pb-8"
            src="https://cdn.pmlsound.com/anthem/avm90/images/avm-mca-stack.png"
          />
          <div className="bg-black/50 md:bg-inherit py-48 px-6 relative">
            <div className="max-w-7xl mx-auto text-white  md:text-gray-900 relative ">
              <div className="visible lg:invisible lg:mb-0 mb-10 lg:h-0 h-auto ">
                {title}
              </div>

              <div class="flex-wrap flex ">
                <div className="relative w-full lg:w-2/5 lg:py-28 z-10">
                  <div className="invisible lg:visible lg:h-auto h-10 ">
                    {title}
                  </div>
                  <p className="text-white mb-16 text-xl font-light lg:mt-10 lg:text-left text-center ">
                    Today's premium home theaters need support for as many as 15
                    speakers and four subwoofers to handle the latest Dolby
                    Atmos and DTS:X object-oriented audio codecs. Pair the AVM
                    90 A/V Processor with a stack of MCA amplifiers and you'll
                    hear sound that rivals the best commercial cinemas.
                    <br />
                    <br />
                    MCA's scalability means you can purchase only the channels
                    you need to power your vision of home entertainment. The AVM
                    90 Processor can manage configurations up to 15.4 channels
                    (up from 11.2) with ARC Genesis Room Correction ensuring the
                    best possible sound at every seat.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LimitlessPossibilies;
